import { createTheme } from '@mui/material/styles';

export const darkFinanceTheme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#FFD700',
            contrastText: '#0D0D1A',
        },
        secondary: {
            main: '#00D1FF',
        },
        success: {
            main: '#00FFA3',
        },
        error: {
            main: '#FF4F4F',
        },
        background: {
            default: '#0D0D1A',
            paper: '#1A1A2E',
        },
        text: {
            primary: '#FFFFFF',
            secondary: 'rgba(255,255,255,0.6)',
        },
    },
    typography: {
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    backgroundColor: '#0D0D1A',
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    backgroundColor: 'rgba(255,255,255,0.04)',
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'rgba(255,255,255,0.18)',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'rgba(0,209,255,0.5)',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#00D1FF',
                        borderWidth: '1.5px',
                    },
                    '&.Mui-error .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#FF4F4F',
                    },
                },
                input: {
                    color: '#FFFFFF',
                    '&::placeholder': {
                        color: 'rgba(255,255,255,0.35)',
                        opacity: 1,
                    },
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    color: 'rgba(255,255,255,0.55)',
                    fontSize: '0.875rem',
                    '&.Mui-focused': {
                        color: '#00D1FF',
                    },
                    '&.Mui-error': {
                        color: '#FF4F4F',
                    },
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                containedPrimary: {
                    backgroundColor: '#FFD700',
                    color: '#0D0D1A',
                    fontWeight: 700,
                    letterSpacing: '0.5px',
                    '&:hover': {
                        backgroundColor: '#FFC800',
                        boxShadow: '0 0 24px rgba(255,215,0,0.35)',
                    },
                    '&.Mui-disabled': {
                        backgroundColor: 'rgba(255,215,0,0.25)',
                        color: 'rgba(13,13,26,0.4)',
                    },
                },
            },
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    color: 'rgba(255,255,255,0.5)',
                    '&:hover': {
                        color: '#00D1FF',
                        backgroundColor: 'rgba(0,209,255,0.08)',
                    },
                },
            },
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    '&.Mui-error': {
                        color: '#FF4F4F',
                    },
                },
            },
        },
        MuiTableContainer: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                    boxShadow: 'none',
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    borderColor: 'rgba(255,255,255,0.06)',
                    fontSize: '0.82rem',
                },
                head: {
                    backgroundColor: 'rgba(255,215,0,0.05)',
                },
            },
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    '&:last-child td, &:last-child th': {
                        borderBottom: 0,
                    },
                },
            },
        },
    },
});
